import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h2" color="primary" gutterBottom>
          404
        </Typography>
        <Typography variant="h4" gutterBottom>
          Seite nicht gefunden
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 4 }}>
          Die von Ihnen gesuchte Seite scheint nicht zu existieren oder wurde verschoben.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => navigate('/')}
          >
            Zur Startseite
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => navigate(-1)}
          >
            Zurück
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFoundPage;
